import {SWEAGENT_CAPI_MODEL_PREFIX} from './constants'

export function trimModelName(modelName: string): string {
  return modelName.startsWith(SWEAGENT_CAPI_MODEL_PREFIX)
    ? modelName.slice(SWEAGENT_CAPI_MODEL_PREFIX.length)
    : modelName
}
